/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CouponDto } from '../../models/coupon-dto';

export interface TeacherCouponControllerFindById$Params {
  id: string;
}

export function teacherCouponControllerFindById(http: HttpClient, rootUrl: string, params: TeacherCouponControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<CouponDto>> {
  const rb = new RequestBuilder(rootUrl, teacherCouponControllerFindById.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CouponDto>;
    })
  );
}

teacherCouponControllerFindById.PATH = '/api/teacher-coupon/{id}';
